import { useEffect, useState } from "react";
import { gql } from "@apollo/client";
import { useQuery} from "@apollo/client/react";
import { useAppConfig } from "@ct-react/core";
import { useLocaleContext } from "@ct-react/locale";
import { CmsPageContent, extractCmsContent } from "@shared/graphql";
import { Wrapper } from "../components/layout/wrapper";
import SeoMetas from "../components/layout/seo-metas";

import "./useful-info.scss";

const CMS_PAGE_GQL_DATA = gql`
  query InfoCmsPage($templateId: UUID!) {
    cmsPages(templateId: $templateId) { data }
  }
`;

const Useful_info = () => {

  const { locale } = useLocaleContext();
  const { options: { cmsTemplates: { info: templateId } } } = useAppConfig();
  const [ cmsContent, setCmsContent ] = useState<CmsPageContent | undefined>(undefined);

  const { data } = useQuery<any>(CMS_PAGE_GQL_DATA, {
    variables: { templateId },
    ssr: true
  });

  useEffect(() => {
    if (!data?.cmsPages || data.cmsPages.length === 0) return;
    setCmsContent(extractCmsContent(data.cmsPages[0].data, locale));
  }, [ data, locale ]);

  return (
    <Wrapper.Centered className="useful-info">

      {(() => {
        if (!data?.cmsPages) return null;
        const seo = extractCmsContent(data!.cmsPages[0].data, locale)["seo-data"];
        return (
          <SeoMetas title={seo["seo-title"]}
                    description={seo["seo-description"]}
                    keywords={seo["seo-keywords"]?.split(",").map((k: string) => k.trim()) || []} />);
      })()}

      {!!cmsContent &&
        <>
          <h1>{cmsContent["info-title"]}</h1>
          {(!!cmsContent && !!cmsContent["info-sections-items"]) &&
            cmsContent["info-sections-items"].map((item: any, index: number) => (
              <details key={index} name="exclusive">
                <summary>
                  <img src={item["section-icon"].originalUrl} alt={item["section-icon"].alternativeText} />
                  {item['section-name']}
                </summary>
                <div  className="desc"
                      dangerouslySetInnerHTML={{ __html: item['section-detail'] }} />
              </details>
            ))
          }
        </>
      }

    </Wrapper.Centered>);

};

export default Useful_info;
